<template>
  <div>
    <Layout
      :stageTitle="$t(stageTitle)"
      :stageSubTitle="$t(stageSubTitle)"
      footer
    >
      <EditPersonTab1 :formValid.sync="internalValid" />
    </Layout>
  </div>
</template>

<script>
  import EditPersonTab1 from '@/components/RightDrawer/form/EditPersonTabPerso'
  import Layout from '@/pages/Subscriber/steps-sub/Layout'

  export default {
    components: {
      Layout,
      EditPersonTab1,
    },
    props: {
      formValid: {
        type: Boolean,
        default: false,
      },
      stageTitle: {
        type: String,
        required: true,
      },
      stageSubTitle: {
        type: String,
        required: true,
      },
    },
    computed: {
      internalValid: {
        get() {
          return this.formValid
        },
        set(value) {
          return this.$emit('update:formValid', value)
        },
      },
    },
  }
</script>
